import { apiService } from '..';
import { ToastSwal } from '../../components/components/general/toastSwals/toastSwal';
import { PreviousMessageResponse } from '../../shared/types/assistant';

export const getPreviousMessageUseCase = async (threadId: string) => {
    try {
        const resp = await apiService.get(
            `/api/sam-assistant/previous-messages/${threadId}`
        );

        const replies = resp as PreviousMessageResponse[];

        const filterReplies = replies.filter((item) => item.role !== 'system');

        return filterReplies;
    } catch (error) {
        ToastSwal.fire({
            text: 'Ocurrió un error al obtener los mensajes anteriores.',
            icon: 'error',
            timer: 20000,
            position: 'center-end',
        });
    }
};
